<!--
  ~ Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content id="popup-container">
  <form [formGroup]="deleteValueForm">

    <p>Are you sure you want to delete: </p>
    <strong>{{valueToDelete}}</strong>
    <br/>

    <div id="actions-container">
      <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" id="delete-button" class="action-button"
              (click)="deleteValue()">
        Delete
      </button>
    </div>

  </form>

</div>
